import React from 'react';

type Props = { children: React.ReactNode };

type State = { hasError: boolean };

export class ErrorBoundary extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(_: unknown): State {
    return { hasError: true };
  }

  componentDidCatch(error: unknown, info: unknown) {
    try { console.error('[ErrorBoundary] Error', error, info); } catch {}
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="p-6 text-center text-red-600">
          Ocurrió un error inesperado. Si el problema persiste, desactivá la traducción del navegador e intentá nuevamente.
        </div>
      );
    }
    return this.props.children;
  }
}
